module.exports = __webpack_public_path__ + "assets/9a5a995df8df79a2a239e3c32195f159.jpg";